module.exports = function() {
  return new Worker(__webpack_public_path__ + "c8306f615208d6eff08a.worker.js");
};